export default __webpack_public_path__ + "static/media/icon-list.68ef9c48.svg";